/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createLocation } from '../fn/location/create-location';
import { CreateLocation$Params } from '../fn/location/create-location';
import { deleteLocation } from '../fn/location/delete-location';
import { DeleteLocation$Params } from '../fn/location/delete-location';
import { findLocations } from '../fn/location/find-locations';
import { FindLocations$Params } from '../fn/location/find-locations';
import { inactivateLocation } from '../fn/location/inactivate-location';
import { InactivateLocation$Params } from '../fn/location/inactivate-location';
import { Location } from '../models/location';
import { reactivateLocation } from '../fn/location/reactivate-location';
import { ReactivateLocation$Params } from '../fn/location/reactivate-location';
import { updateLocation } from '../fn/location/update-location';
import { UpdateLocation$Params } from '../fn/location/update-location';

@Injectable({ providedIn: 'root' })
export class LocationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateLocation()` */
  static readonly UpdateLocationPath = '/api/locations/{id}';

  /**
   * Updates a location with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLocation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLocation$Response(params: UpdateLocation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateLocation(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a location with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLocation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLocation(params: UpdateLocation$Params, context?: HttpContext): Observable<void> {
    return this.updateLocation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createLocation()` */
  static readonly CreateLocationPath = '/api/locations/{id}';

  /**
   * Creates a location with the given id, an address and a configuration type Location
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLocation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLocation$Response(params: CreateLocation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createLocation(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a location with the given id, an address and a configuration type Location
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLocation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLocation(params: CreateLocation$Params, context?: HttpContext): Observable<void> {
    return this.createLocation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteLocation()` */
  static readonly DeleteLocationPath = '/api/locations/{id}';

  /**
   * Delete a location with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteLocation()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLocation$Response(params: DeleteLocation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteLocation(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a location with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteLocation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLocation(params: DeleteLocation$Params, context?: HttpContext): Observable<void> {
    return this.deleteLocation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reactivateLocation()` */
  static readonly ReactivateLocationPath = '/api/locations/{id}/reactivate';

  /**
   * Reactivate a location with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reactivateLocation()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivateLocation$Response(params: ReactivateLocation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return reactivateLocation(this.http, this.rootUrl, params, context);
  }

  /**
   * Reactivate a location with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reactivateLocation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivateLocation(params: ReactivateLocation$Params, context?: HttpContext): Observable<void> {
    return this.reactivateLocation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `inactivateLocation()` */
  static readonly InactivateLocationPath = '/api/locations/{id}/inactivate';

  /**
   * Inactivate a location with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inactivateLocation()` instead.
   *
   * This method doesn't expect any request body.
   */
  inactivateLocation$Response(params: InactivateLocation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return inactivateLocation(this.http, this.rootUrl, params, context);
  }

  /**
   * Inactivate a location with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inactivateLocation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inactivateLocation(params: InactivateLocation$Params, context?: HttpContext): Observable<void> {
    return this.inactivateLocation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `findLocations()` */
  static readonly FindLocationsPath = '/api/locations';

  /**
   * Return locations
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findLocations()` instead.
   *
   * This method doesn't expect any request body.
   */
  findLocations$Response(params?: FindLocations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Location>>> {
    return findLocations(this.http, this.rootUrl, params, context);
  }

  /**
   * Return locations
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findLocations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findLocations(params?: FindLocations$Params, context?: HttpContext): Observable<Array<Location>> {
    return this.findLocations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Location>>): Array<Location> => r.body)
    );
  }

}
